import SoundToggleComponent from "slotworks/components/sound/sound-toggle-component";
import Layers from "slotworks/graphics/layers/layers";
import { Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { AbstractControl } from "../control";

export default class SoundToggleControl extends AbstractControl implements Control {

    public soundToggle: SoundToggleComponent;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        const soundOnButton = layer.getFlexiButton(assetName + "_on");
        const soundOffButton = layer.getFlexiButton(assetName + "_off");
        const soundLoading = layer.getFlexiSprite(assetName + "_loading");

        this.soundToggle = new SoundToggleComponent(soundOnButton, soundOffButton, soundLoading);
    }

    public setVisible(visible: boolean) {
        this.soundToggle.setVisible(visible);
    }

    public setEnabled(enabled: boolean) {
        if (this.soundToggle) {
            this.soundToggle.setEnabled(enabled);
        }
    }

    public destroy() {
        if (this.soundToggle) {
            this.soundToggle.destroy();
        }
    }
}
